import { defineStore } from 'pinia'

type EParems = {
  receiverInfos: Array<any>
  [key: string]: any
}
export const useExpressStore = defineStore('express', {
  state: () => ({
    expressLetter: {} as EParems
  }),
  getters: {
    getExpressLetter: (state) => state.expressLetter
  },
  actions: {
    setExpressletter(params: EParems) {
      this.expressLetter = params
    }
  }
  // persist: {
  //   storage: localStorage
  // }
})
